// extracted by mini-css-extract-plugin
export default {"tooltip":"Tooltip-module__tooltip__cXtmx","content":"Tooltip-module__content__8moBn","title":"Tooltip-module__title__rPdru","text":"Tooltip-module__text__PIJBr"};